import $ from 'jquery';

export default function Resize(error) {
    const userAgent = window.navigator.userAgent.toLowerCase();
    const isAndroid = userAgent.includes('android');

    if (isAndroid) {
        // New logic for Android
        const browserHeight = window.innerHeight;
        const browserWidth = window.innerWidth;

        // Normalize width to DIP (density-independent pixels)
        const normalizedWidth = browserWidth / window.devicePixelRatio;

        // Define breakpoint based on DIP width (600 DIP as a rough cutoff)
        const isTabletOrLarger = normalizedWidth >= 600;

        const contentHeight = isTabletOrLarger ? 768 : 375;
        const scale = browserHeight / contentHeight;

        $('html').css({
            'transform': `scale(${scale})`,
            'width': `${browserWidth / scale}px`
        });

        $('html').toggleClass('handheld', !isTabletOrLarger);
    } else {
        // Old logic for iOS and other platforms
        // (Assuming that for non-Android devices, your original scaling behavior works correctly)
        const isHandheld = /iphone|ipod|webos|blackberry|ipad/.test(userAgent);
        const contentHeight = isHandheld ? 375 : 768;
        const browserHeight = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
        const browserWidth = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
        const scale = browserHeight / contentHeight;

        $('html').css({
            'transform': 'scale(' + scale + ')',
            'width': browserWidth / scale,
        });

        if (isHandheld) {
            $('html').addClass('handheld');
        } else {
            $('html').removeClass('handheld');
        }
    }
}
